<template>
    <div :class="['row', cssClass]">
        <div class="col-12 col-md-10 col-md-offset-1 col-lg-9 col-xl-offset-4">
            <div class="page-title">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
            name: 'AccountTitleSection',
            props: {
                cssClass: {
                    type: String
                },
            }
    }
</script>